import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../../service/serviceURL';
import { NgForm } from '@angular/forms';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
    isProspect: boolean = true;
    isClient: boolean = false;
    isRenewals: boolean = false;
    isProspectHighLight: boolean = true;
    isClientHighLight: boolean = false;
    isRenewalsHighLight: boolean = false;
    isProspectLength: boolean = false;
    isClientLength: boolean = false;
    isRenewalsLength: boolean ;
    isComment:boolean=false;
    searchMobileLead:boolean=false;
    SearchProspectLead:boolean=false;
    roleData: any = {};
    roleDataPam: any = {};
    prospectData: any ;
    clientData: any ;
    renewalData: any;
    loading: boolean;
    leadList:any[];
    leadList2:any[];
    searchLeadList:any[];
    clientList:any[];
    clientList2:any[];
    renewalList:any[];
    renewalList2:any[];
    totalLength:any;
    page:number=1;
    count:number;
    mobileValue:any;
    ProspectName:any;
    commentSectionData:any;
    commentList:any[];
    isValidCommentForm:boolean;
    commentAPIdata:any;
    cancelCheck:string;
    dynamicCommentTh:any;
    dynamicCommentTd:any;
    dynamicCommentFor:any;
    logedinUser:any;
    placeholderValue:any="Search by Prospect";

    constructor(private router: Router, private location: Location, private serviceURLService: serviceURLService) {
        this.roleDataPam = JSON.parse(localStorage.getItem('role_pam'));
        this.logedinUser = localStorage.getItem('name');
    }

    ngOnInit() {
       // this.roleData = JSON.parse(localStorage.getItem('role'));
       // this.getRmProspects();
       this.getDashboardData();
    }

    SearchMobile(){
    // start search for prospect using mobile.
    if(this.isProspect){
       if(this.mobileValue==""){
       this.searchMobileLead=false;
       this.ngOnInit();
       
        }
         else{
          this.leadList=this.leadList2;
          this.leadList=this.leadList.filter(res =>{
          return res.mobile.toLocaleLowerCase().match(this.mobileValue.toLocaleLowerCase());
            });

            if(!this.leadList.length){
              this.searchMobileLead=true;
             }
             else{
              this.searchMobileLead=false;
             }
        }
        this.totalLength=this.leadList.length;
        this.page=1;
        console.log(" total length= "+this.totalLength +" mobile value= "+this.mobileValue+" mobile length "+this.mobileValue.length);   
        }
         // end search for prospect using mobile.
         
        // search for client using mobile.
        if(this.isClient){
          if(this.mobileValue==""){
          this.searchMobileLead=false;
          this.clientList=this.clientList2;
          
           }
            else{
             this.clientList=this.clientList2;
             this.clientList=this.clientList.filter(res =>{
             return res.mobile.toLocaleLowerCase().match(this.mobileValue.toLocaleLowerCase());
               });
   
               if(!this.clientList.length){
                 this.searchMobileLead=true;
                }
                else{
                 this.searchMobileLead=false;
                }
           }
           this.totalLength=this.clientList.length;
           this.page=1;
           console.log(" total length= "+this.totalLength +" mobile value= "+this.mobileValue+" mobile length "+this.mobileValue.length);   
           }
        // end search for client using mobile.

       // start search for renewal using mobile.
      if(this.isRenewals){
        if(this.mobileValue==""){
        this.searchMobileLead=false;
        this.renewalList=this.renewalList2;
        
         }
          else{
           this.renewalList=this.renewalList2;
           this.renewalList=this.renewalList.filter(res =>{
           return res.mobile.toLocaleLowerCase().match(this.mobileValue.toLocaleLowerCase());
             });
 
             if(!this.renewalList.length){
               this.searchMobileLead=true;
              }
              else{
               this.searchMobileLead=false;
              }
         }
         this.totalLength=this.renewalList.length;
         this.page=1;
         console.log(" total length= "+this.totalLength +" mobile value= "+this.mobileValue+" mobile length "+this.mobileValue.length);   
         }
       // end search for renewal using mobile.
   }

    SearchProspectName(){
      // start search for prospect using name.
      if(this.isProspect){
        if(this.ProspectName==""){
      this.SearchProspectLead=false;
      console.log("if value "+this.SearchProspectLead)
      this.ngOnInit();
       }
        else{
         this.leadList=this.leadList2;
         this.leadList=this.leadList.filter(res =>{
         return res.clientName.toLocaleLowerCase().match(this.ProspectName.toLocaleLowerCase());
           });

           if(!this.leadList.length){
             this.SearchProspectLead=true;
            }
            else{
              this.SearchProspectLead=false;
             }
       }
       this.totalLength=this.leadList.length;
       this.page=1;
       console.log(" total length= "+this.totalLength +" ProspectName value= "+this.ProspectName+" ProspectName length "+this.ProspectName.length);   
      }
      // end search for prospect using name.

     // start search for client using name.
          if(this.isClient){
            if(this.ProspectName==""){
          this.SearchProspectLead=false;
          console.log("if value "+this.SearchProspectLead)
          this.clientList=this.clientList2;
           }
            else{
             this.clientList=this.clientList2;
             this.clientList=this.clientList.filter(res =>{
             return res.clientName.toLocaleLowerCase().match(this.ProspectName.toLocaleLowerCase());
               });
    
               if(!this.clientList.length){
                 this.SearchProspectLead=true;
                }
                else{
                  this.SearchProspectLead=false;
                 }
           }
           this.totalLength=this.clientList.length;
           this.page=1;
           console.log(" total length= "+this.totalLength +" ProspectName value= "+this.ProspectName+" ProspectName length "+this.ProspectName.length);   
          }
      // end search for client using name.

      // start search for renewal using name.
      if(this.isRenewals){
        if(this.ProspectName==""){
      this.SearchProspectLead=false;
      console.log("if value "+this.SearchProspectLead)
      this.renewalList=this.renewalList2;
       }
        else{
         this.renewalList=this.renewalList2;
         this.renewalList=this.renewalList.filter(res =>{
         return res.clientName.toLocaleLowerCase().match(this.ProspectName.toLocaleLowerCase());
           });

           if(!this.renewalList.length){
             this.SearchProspectLead=true;
            }
            else{
              this.SearchProspectLead=false;
             }
       }
       this.totalLength=this.renewalList.length;
       this.page=1;
       console.log(" total length= "+this.totalLength +" ProspectName value= "+this.ProspectName+" ProspectName length "+this.ProspectName.length);   
      }
      // end search for renewal using name.
}

    getDashboardData(){
        this.serviceURLService.getDashboardData(this.roleDataPam.pamUserID).subscribe((successData: any) => {
        this.leadList=successData.data.leadData;
        this.leadList2=successData.data.leadData;
        this.clientList=successData.data.clientData;
        this.clientList2=successData.data.clientData;
        this.renewalList=successData.data.renewaltData;
        this.renewalList2=successData.data.renewaltData;
        this.totalLength=this.leadList.length;
        this.count=0;
        if( this.leadList.length){
            this.isProspectLength=true;
        }
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
          console.log("Please login first");
        } 
      })
      }

      getComment(leadId){
        this.serviceURLService.getAgentComment(leadId).subscribe((successData: any) => {
        this.leadList=successData.data.leadData;
        this.leadList2=successData.data.leadData;
        
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
          console.log("Please login first");
        } 
      })
      }

      addComment(leaddata){
        this.commentSectionData=leaddata;
        if(this.commentSectionData.hasOwnProperty('status'))
         {
          this.dynamicCommentTh="Status";
          this.dynamicCommentTd=this.commentSectionData.status;
          this.dynamicCommentFor="prospect";
         }
         if(this.commentSectionData.hasOwnProperty('renewalDate'))
         {
          this.dynamicCommentTh="Renewal Date";
          this.dynamicCommentTd=this.commentSectionData.renewalDate.split(" ")[0];
          this.dynamicCommentFor="renewal";
         }
        this.isRenewals=false;
        this.isProspect= false;
        this.isComment=true;
       //comment fetch
        this.serviceURLService.getAgentComment(leaddata.id).subscribe((successData: any) => {
             this.commentList=successData.data;
                  
        }, errorData => {
          if (errorData.error.status === 401) {
            this.router.navigate(['/login']);
            console.log("Please login first");
          } 
        })
      }
      onCommentSubmit(form: NgForm){
        this.isValidCommentForm = false;
		    if (form.valid) {
          this.isValidCommentForm = true;
		   	// comment-update API call
         this.commentAPIdata =
         {
          comment:JSON.parse(JSON.stringify(form.value.setcomment)),
          id: this.commentSectionData.id,
          commentByName: this.logedinUser,
          commentById:this.roleDataPam.pamUserID
         }
          this.serviceURLService.updateComment(this.commentAPIdata).subscribe((successData: any) => {
            if(successData.data.isSuccess){
              this.addComment(this.commentSectionData);
              form.resetForm();
            }else{

            }
          }, errorData => {
            if (errorData.error.status === 401) {
              this.router.navigate(['/login']);
              console.log("Please login first");
                } 
             })
	     	} else {
		    	return;
	      	}
		
      }

      resetCommentForm(form: NgForm){
        form.resetForm();
      }
      cancelCommentForm(){
        this.isComment=false;
        if(this.commentSectionData.hasOwnProperty('status'))
        {
          this.isProspect= true;
        }
        if(this.commentSectionData.hasOwnProperty('renewalDate'))
        {
          this.isRenewals=true;
        }  
      }

      getRmProspects(){
        this.placeholderValue="Search by Prospect"
        this.isComment=false;
        this.isProspect= true;
        this.isProspectHighLight= true;
        this.isClient = false;
        this.isClientHighLight = false;
        this.isRenewals = false;
        this.isRenewalsHighLight = false;
        this.count=0;
        this.totalLength=this.leadList.length;
        this.page=1;
        if( this.leadList.length){
            this.isProspectLength=true;
        }
      }
      getRmClients(){
        this.placeholderValue="Search by Client"
        this.isComment=false;
        this.isProspect= false;
        this.isProspectHighLight= false;
        this.isClient = true;
        this.isClientHighLight = true;
        this.isRenewals = false;
        this.isRenewalsHighLight = false;
        this.count=0;
        this.totalLength=this.clientList.length;
        this.page=1;
        if( this.clientList.length){
            this.isClientLength=true;

        }
      }
      getRmRenewals(){
        this.placeholderValue="Search by Client"
        this.isComment=false;
        this.isProspect= false;
        this.isProspectHighLight= false;
        this.isClient = false;
        this.isClientHighLight = false;
        this.isRenewals = true;
        this.isRenewalsHighLight = true;
        this.count=0;
        this.totalLength=this.renewalList.length;
        this.page=1;
        if( this.renewalList.length){
            this.isRenewalsLength=true;
        }
      }

      key:string='id';
      reverse:boolean=false;
      sort(key){
        this.key=key;
        this.reverse=!this.reverse;
      }

//COMMENTING OUT OLD CODE WHICH WAS STATIC VIEW ONLY WITH HARD CODED DATA VALUES....
    // getRmProspects() {
    //     this.loading = true;
    //     const formData: FormData = new FormData();
    //     formData.append('displayForTeamMember', 'true');
    //     formData.append('selectedRMId', this.roleData.pamUserID);
    //     formData.append('iDisplayStart', '0');
    //     formData.append('iDisplayLength', '8');
    //     this.serviceURLService.getRmProspects(formData).subscribe((successData: any) => {
    //         this.prospectData = successData.prospects;
    //         this.isProspect = true;
    //         this.isClient = false;
    //         this.isRenewals = false;
    //         this.loading = false;
    //     }, errorData => {
    //         this.loading = false;
    //     }
    //   )
    // }

    // getRmClients() {
    //     this.loading = true;
    //     const formData: FormData = new FormData();
    //     formData.append('displayForTeamMember', 'true');
    //     formData.append('selectedRMId', this.roleData.pamUserID);
    //     formData.append('iDisplayStart', '0');
    //     formData.append('iDisplayLength', '8');
    //     this.serviceURLService.getRmClients(formData).subscribe((successData: any) => {
    //         this.clientData = successData.clients;
    //         this.isProspect = false;
    //         this.isClient = true;
    //         this.isRenewals = false;
    //         this.loading = false;
    //     }, errorData => {
    //         this.loading = false;
    //     }
    //   )
    // }

    // getRmRenewals() {
    //     this.loading = true;
    //     const formData: FormData = new FormData();
    //     formData.append('displayForTeamMember', 'true');
    //     formData.append('selectedRMId', this.roleData.pamUserID);
    //     formData.append('iDisplayStart', '0');
    //     formData.append('iDisplayLength', '8');
    //     this.serviceURLService.getRMRenewals(formData).subscribe((successData: any) => {
    //         this.renewalData = successData.policies;
    //         this.isProspect = false;
    //         this.isClient = false;
    //         this.isRenewals = true;
    //         this.loading = false;
    //     }, errorData => {
    //         this.loading = false;
    //     }
    //   )
    // }

   

}